// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import accountReducer from './slices/account';
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import projectReducer from './slices/project';
import vectorReducer from './slices/vector';
import datahubProjectReducer from './slices/datahubProject';
import datahubStorageReducer from './slices/datahubStorage';
import datahubDatabaseReducer from './slices/datahubDatabase';
import datahubJupyterReducer from './slices/datahubJupyter';
import datahubWorkflowReducer from './slices/datahubWorkflow';
import sitemapReducer from './slices/sitemap';
import personaReducer from './slices/persona';
import uploadedFileReducer from './slices/uploadedfile';
import lambdaFunctionsReducer from './slices/lambdaFunctions';
import storageReducer from './slices/storage';
// import jupyterhubReducer from './slices/jupyterhubSlice'; // Rollback - V2 component disabled

import { conversationSlice } from '../views/workspace/document/conversationSlice';
import { prefSlice } from '../views/workspace/document/preferences/preferenceSlice';
import { conversationMindmapSlice } from 'views/workspace/mindmap/conversationSlice';
import { prefMindmapSlice } from 'views/workspace/mindmap/preferences/preferenceSlice';
import apiSlice from './slices/apiSlice';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'berry-'
        },
        cartReducer
    ),
    account: accountReducer,
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    vector: vectorReducer,
    persona: personaReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    project: projectReducer,
    uploadedFile: uploadedFileReducer,
    sitemap: sitemapReducer,
    lambdaFunctions: lambdaFunctionsReducer,
    storage: storageReducer,
    datahubProject: datahubProjectReducer,
    datahubStorage: datahubStorageReducer,
    datahubDatabase: datahubDatabaseReducer,
    datahubJupyter: datahubJupyterReducer,
    datahubWorkflow: datahubWorkflowReducer,
    // jupyterhub: jupyterhubReducer, // Rollback - V2 component disabled
    preference: prefSlice.reducer,
    preferenceMindmap: prefMindmapSlice.reducer,
    conversation: conversationSlice.reducer,
    conversationMindmap: conversationMindmapSlice.reducer,
    api: apiSlice.reducer
});

export default reducer;
